import React from "react";
import Box from "../Box/Box";
import PropTypes from "prop-types";
import Notify from "../../services/Notify";
import Loading from "../Loading/Loading";
import TemplatesDashboardService from "../../services/TemplatesDashboardService";
import BizLocationSelector from "../BizLocation/BizLocationSelector";
import DispositionSelector from "../../disposition/DispositionSelector";
import BizStepSelector from "../BizStep/BizStepSelector";
import DashboardTemplatesSelector from "./DashboardTemplatesSelector";
import FormButtons from "../Form/FormButtons";

class DashboardTemplatesForm extends React.Component {

  service = new TemplatesDashboardService();

  constructor(props) {
    super(props);
    this.state = {};
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;

    if (id) {
      const state = this.state;
      this.setState(state);

      state.loading = true;

      this.service.findById(id)
      .then(
          data => this.setState({
            loading: false,
            entity: data
          }),
          error => {
            const state = {loading: false};
            if (error.response.status === 404) {
              state.message = 'Entidade não encontrada!';
            } else {
              state.message = 'Erro inesperado!';
              Notify.error('Falha o buscar entidade!', error)
            }
            this.setState(state);
          }
      )
    }

  }

  submitForm() {
    const existingEntity = this.state.entity && this.state.entity.id;
    const entityVersion = this.state.entity && this.state.entity.version;

    console.log('asd asd asd asd');

    const entity = {
      id: existingEntity || null,
      type: this.type,
      dispositions: this.dispositions,
      bizLocation: {id: this.bizLocationId},
      bizSteps: this.bizSteps,
      version: entityVersion
    };
    this.setState({loading: true, message: 'Salvando...'});
    this.service.save(entity).then(
        () => {
          this.props.history.goBack();
          Notify.success('Entidade salva');
        },
        (error) => {
          Notify.error('Falha ao salvar entidade:', error);
          this.setState({loading: false, entity, message: null});
        });
  }

  onChange(event) {
    const target = event.target;
    this.state.isIntegrated = target.type === 'checkbox' ? target.checked : target.value;
    this.setState(this.state);
  }

  render() {

    const {loading, entity, message} = this.state;

    if (loading) {
      return <Loading message={message}/>
    }
    if (message) {
      return <h2>{message}</h2>
    }

    return (
        <Box info>
          <form onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>
            <DashboardTemplatesSelector
                multiple={false}
                required={true}
                defaultValue={entity && entity.type}
                setValue={type => this.type = type}
            />

            <BizLocationSelector
                multiple={false}
                required={true}
                defaultValue={entity && entity.bizLocation && entity.bizLocation.id}
                setValue={bizLocationId => this.bizLocationId = bizLocationId}
            />

            <DispositionSelector
                multiple={true}
                required={true}
                defaultValue={entity && entity.dispositions}
                setValue={disposition => this.dispositions = disposition}
            />

            <BizStepSelector
                multiple={true}
                required={true}
                defaultValue={entity && entity.bizSteps}
                setValue={bizStepId => this.bizSteps = bizStepId}
            />

            <FormButtons history={this.props.history}/>
          </form>
        </Box>);
  }
}

DashboardTemplatesForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default DashboardTemplatesForm;



// WEBPACK FOOTER //
// ./src/component/DashboardTemplates/DashboardTemplatesForm.js